module.exports = __webpack_public_path__ + "img/ZSDZ.8db73063.png";